import React, { Component } from 'react';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles, override } from '../helpers/utils.js';
import axios from 'axios';
import config from 'react-global-configuration';
import StoreFilter from '../filters/StoreFilter2.jsx';
import { BeatLoader } from "react-spinners";

// Integrates StoreFilter2 (for stores) and granular APIs for other filters.
class BeatPlanFilters extends Component {
    constructor(props) {
        super(props);
        this.state = {
            storeCategoryOptions: [],
            cityOptions: [],
            visitStatusOptions: [],
            loading: true
        };
    }

    componentDidMount() {
        this.fetchAllOptions();
    }

    fetchAllOptions = () => {
        const token = localStorage.usertoken;
        const headers = { Authorization: ` ${token}` };
        const apiUrl = config.get('API_URL');

        const requestOne = axios.get(`${apiUrl}/filters/beatplan/get-store-categories`, { headers });
        const requestTwo = axios.get(`${apiUrl}/filters/beatplan/get-visit-status`, { headers });
        const requestThree = axios.get(`${apiUrl}/filters/beatplan/get-city`, { headers });

        axios.all([requestOne, requestTwo, requestThree]).then(axios.spread((...responses) => {
            console.log("BeatPlanFilters API Responses:", responses);
            const categoriesData = responses[0].data || [];
            const statusData = responses[1].data || [];
            const citiesData = responses[2].data || [];
            console.log("Categories:", categoriesData);
            console.log("Status:", statusData);
            console.log("Cities:", citiesData);

            this.setState({
                storeCategoryOptions: categoriesData.map(c => ({ label: c.store_category, value: c.store_category })),
                visitStatusOptions: statusData.map(s => ({ label: s.visit_status, value: s.visit_status })),
                cityOptions: citiesData.map(c => ({ label: c.city_name, value: c.city_name })),
                loading: false
            });
        })).catch(errors => {
            console.error(errors);
            this.setState({ loading: false });
        });
    }

    handleStoreChange = (storeCodes) => {
        // Updates parent with selected store codes. UI state is managed internally by StoreFilter2.
        this.props.onFilterChange('store_code', storeCodes, null);
    }

    render() {
        const {
            storeCategoryValue,
            cityValue,
            visitStatusValue,
            onFilterChange,
            object_type,
            object_code,
            user_type
        } = this.props;

        const {
            storeCategoryOptions,
            cityOptions,
            visitStatusOptions,
            loading
        } = this.state;

        if (loading) {
            return (
                <div className="col-md-12 text-center" style={{ padding: '20px' }}>
                    <BeatLoader
                        css={override}
                        sizeUnit={"px"}
                        size={5}
                        color={'#666666'}
                        loading={loading}
                    />
                    <p>Loading filters...</p>
                </div>
            );
        }

        return (
            <div className="col-md-12">
                <div className="col-md-3 filter-bottom5 padd-5">
                    <label>Store</label>
                    <StoreFilter 
                        object_type={object_type}
                        object_code={object_code}
                        onSelectStore={this.handleStoreChange}
                        user_type={user_type}
                    />
                </div>
                <div className="col-md-3 filter-bottom5 padd-5">
                    <label>Store Category</label>
                    <ReactMultiSelectCheckboxes
                        options={storeCategoryOptions}
                        value={storeCategoryValue}
                        onChange={(selected) => onFilterChange('store_category', selected ? selected.map(i => i.value) : [], selected)}
                        styles={reactSelectStyles}
                        className="report-listbox"
                        placeholderButtonLabel="Select [Category]"
                    />
                </div>
                {/* Store Code is covered by StoreFilter, so removing separate Store Code dropdown */}
                
                <div className="col-md-3 filter-bottom5 padd-5">
                    <label>City</label>
                    <ReactMultiSelectCheckboxes
                        options={cityOptions}
                        value={cityValue}
                        onChange={(selected) => onFilterChange('city', selected ? selected.map(i => i.value) : [], selected)}
                        styles={reactSelectStyles}
                        className="report-listbox"
                        placeholderButtonLabel="Select [City]"
                    />
                </div>
                <div className="col-md-3 filter-bottom5 padd-5">
                    <label>Visit Status</label>
                    <ReactMultiSelectCheckboxes
                        options={visitStatusOptions}
                        value={visitStatusValue}
                        onChange={(selected) => onFilterChange('visit_status', selected ? selected.map(i => i.value) : [], selected)}
                        styles={reactSelectStyles}
                        className="report-listbox"
                        placeholderButtonLabel="Select [Status]"
                    />
                </div>
            </div>
        );
    }
}

export default BeatPlanFilters;
